import React, { useState, useEffect, useRef } from 'react'
import { toast } from 'react-toastify'
import stockApi from '../../services/StockApi'
import Text from '../../components/Text'
import ReceivementFreshForm from './components/ReceivementFreshForm'
import FlexLayout from '../../components/FlexLayout'
import {
    Formik, Form, Field, ErrorMessage
} from 'formik'
import FormField from '../../components/Form/FormField'
import Button from '../../components/Button'
import * as Yup from 'yup'
import ReactSelect from "react-select"
import Helper from '../../services/Helper'
import NumberFormat from 'react-number-format'
import { DarkBlue } from '../../assets/colors'
import ReactTable from 'react-table'
import 'react-table/react-table.css'
import './../../App.css'
import { useFulfillmentCenter } from 'src/hooks/useFulfillmentCenter';

function ReceivementFresh() {

    const fieldStyle = {
        background: 'rgba(246, 246, 246, 0.6)',
        border: 0,
        borderBottom: `3px solid ${DarkBlue}`,
        width: '100%'
    }

    const { fc } = useFulfillmentCenter()

    const [receivementTable, setReceivementTable] = useState([]);
    const [pendencyReceivementTable, setPendencyReceivementTable] = useState([]);
    const [optionsSelect, setOptionsSelect] = useState([]);
    const [optionSelected, setOptionSelected] = useState(undefined);
    const [receivementId, setReceivementId] = useState(null);
    const [provider, setProvider] = useState(' ');
    const [invoiceNumber, setInvoiceNumber] = useState(' ');
    const [barCodeUser, setBarCodeUser] = useState(null);
    const [nextStep, setNextStep] = useState(false);
    const [errorProducts, setErrorProducts] = useState('');
    const [haveBillet, ShowBilletBarCode] = useState(false);
    const [hasPurchaseOrderCode, setHasPurchaseOrderCode] = useState(true)
    const [error, setError] = useState(undefined);

    const carTemperatureRef = useRef();
    const purchaseOrderCodeRef = useRef();
    const checkboxRef = useRef();
    const billetBarCodeRef = useRef();

    useEffect(() => {
        stockApi.get('/fornecedores').then((resp) => {
            let array = [];
            resp.data.fornecedores.map((fornecedor) => {
                array.push({ "value": fornecedor.id_fornecedor, "description": fornecedor.nm_fornecedor });
            });
            setOptionsSelect(array.map((option) => ({ value: option.value, label: option.description })));
        });
    }, [])

    const createReceivementFresh = (values, resetForm, setStatus, setSubmitting, setErrors) => {
        setStatus()
        const options = {
            headers: {
                'user-barcode': values.barcodeUser
            }
        };
        let data = {
            id_fornecedor: values.provider,
            nota_fiscal: values.invoice,
            numero_arf: values.purchaseOrderCode ? values.purchaseOrderCode : null,
            valor_nf: values.invoiceValue,
            codigo_barras_boleto: values.billetBarCode,
            tipo_recebimento: Helper.TypesReceivement.FRESH,
            temperatura_carro: values.carTemperature,
            id_fc: fc.id,
        };
        stockApi.post('/recebimento/novo', data, options).then((res) => {
            setReceivementId(res.data.id_recebimento);
            setProvider("Fornecedor: " + optionsSelect.find(opt => opt.value == values.provider).label);
            setInvoiceNumber('Nº Nota Fiscal: ' + values.invoice);
            setNextStep(true);
            setBarCodeUser(values.barcodeUser);
            setError("");
            resetForm();
        })
        .catch((err) => {
            const response = err?.response;
            if(response && response.data) {
                const {message, error_code, payload} = response.data
                if(["INVALID_ORDER_STATUS", "NOT_FOUND", "INVALID_NUMBER_ARF"].includes(error_code)) {
                    setErrors({
                        purchaseOrderCode : message
                    })
                }
                else {
                    setStatus({ error: message });
                }

                payload && console.error(payload)
            }
            else {
                setStatus({ error: "Ocorreu um erro inesperado, tente novamente" });
            }

            setNextStep(false);
            setSubmitting(false);
        });
    }
    const handleFinishReceivement = () => {
        if (receivementTable.length > 0 || pendencyReceivementTable.length > 0) {
            const options = {
                headers: {
                    'user-barcode': barCodeUser
                }
            };

            stockApi.post(`/v2/recebimento/${receivementId}/movement`, {}, options).then(() => {
                setReceivementTable([]);
                setPendencyReceivementTable([]);
                setReceivementId(undefined);
                setProvider(' ');
                setInvoiceNumber(null);
                setBarCodeUser(undefined);
                setNextStep(false);
                setOptionSelected(null);
                setHasPurchaseOrderCode(true)
            }).catch(() => {
                toast.error('Falha ao registrar movimentações')
            })
        }
    }
    useEffect(() => {
        if (receivementTable.length > 0 || pendencyReceivementTable.length > 0) {
            setErrorProducts("");
        }
    }, [receivementTable, pendencyReceivementTable])

    const handleNotHasPurchaseOrderCode = (setFieldValue) => {
        setHasPurchaseOrderCode(prev => {
            let newValue = !prev
            if(!newValue) {
                setFieldValue("purchaseOrderCode", '')
            }
            return newValue
        })
    }

    return (
        <>
            <Text textType="header" text="Recebimento Fresh" />
            {!nextStep ?
                <FlexLayout>
                    <Formik
                        initialValues={{
                            barcodeUser: '',
                            invoice: '',
                            provider: '',
                            purchaseOrderCode: '',
                            invoiceValue: '',
                            billetBarCode: '',
                            carTemperature: ''
                        }}
                        validationSchema={
                            Yup.object().shape({
                                barcodeUser: Yup.string()
                                    .required('form.required')
                                    .test('barcodeUser', 'receivement.form.error.barcodeUser', async (values) => await Helper.validateBarcodeUser(values)),
                                invoice: Yup.string()
                                    .required('form.required')
                                    .max(50, "excedLimitInput"),
                                provider: Yup.string()
                                    .required('form.required'),
                                purchaseOrderCode: Yup.string()
                                    .test('validate-purchaseOrderCode','form.required', (value) => !hasPurchaseOrderCode || value)
                                    .nullable(!hasPurchaseOrderCode)
                                    .trim(),
                                billetBarCode: Yup.string()
                                    .test('validate-billet', 'form.required', (value) => (!haveBillet || value)),
                                invoiceValue: Yup.number()
                                    .required('form.required')
                                    .min(1, 'form.amount.invalid'),
                                carTemperature: Yup.string()
                                    .test('carTemperature', 'receivement.form.error.carTemperature', (values) => (values != undefined ? (parseFloat(values) <= 999.9 && parseFloat(values) >= -999.9) : true)),
                            })
                        }
                        validateOnChange={false}
                        validateOnBlur={false}
                        onSubmit={(values, { resetForm, setStatus, setSubmitting, setErrors }) => {
                            createReceivementFresh(values, resetForm, setStatus, setSubmitting, setErrors)
                        }}
                    >
                        {({ values, setFieldValue, handleBlur, status, handleSubmit, isSubmitting, setTouched, validateField }) => (
                            <Form style={{ width: '500px' }}>
                                <FormField label="barcodeUser" name="barcodeUser" fieldType="password" testId='input-user-barcode' onBlur={() => { validateField("barcodeUser"); setTouched(values) }} />
                                <FormField label="create.receivement.form.invoice" name="invoice" testId='input-invoice-number' onBlur={() => { validateField("invoice"); setTouched(values) }} />
                                <FlexLayout direction="column" style={{ width: "auto", margin: '15px 5px 0 0' }}>
                                    <Text textType="defaut" text="create.receivement.form.provider" />
                                    <div data-testid='select-prodiver'>
                                        <ReactSelect options={optionsSelect}
                                            isClearable={true}
                                            isSearchable={true}
                                            name="provider"
                                            loadingMessage={() => "Carregando fornecedores"}
                                            noOptionsMessage={() => "Sem fornecedores válidos"}
                                            placeholder={"Selecione um fornecedor"}
                                            onChange={(values) => { setOptionSelected(undefined); setFieldValue("provider", values ? values.value : ''); carTemperatureRef.current.focus(); }}
                                            value={optionSelected}
                                        />
                                    </div>
                                    <ErrorMessage component={Text} name="provider" style={{ color: 'red' }} />
                                </FlexLayout>

                                <FlexLayout direction="column" style={{ margin: '15px 0 0 0' }} >
                                    <Text textType="defaut" text="create.receivement.form.carTemperature" />
                                    <NumberFormat name="carTemperature"
                                        data-testid='input-car-temperature'
                                        decimalSeparator=","
                                        decimalScale={1}
                                        allowLeadingZeros={false}
                                        allowNegative={true}
                                        allowEmptyFormatting={false}
                                        value={values.carTemperature}
                                        onValueChange={val => { setFieldValue("carTemperature", val.floatValue, false); }}
                                        style={fieldStyle}
                                        maxLength={6}
                                        getInputRef={carTemperatureRef}
                                        onKeyPress={(event) => {
                                            if (event.key === "Enter") {
                                                purchaseOrderCodeRef.current.focus();
                                            }
                                        }} />
                                    <ErrorMessage component={Text} name="carTemperature" style={{ color: "red" }} />
                                </FlexLayout>


                                <FlexLayout style={{ margin: '15px 0 0 0' }} align="center">
                                    <FormField
                                        label="create.receivement.form.purchaseOrderCode"
                                        name="purchaseOrderCode"
                                        fieldRef={purchaseOrderCodeRef}
                                        isDisabled={!hasPurchaseOrderCode}
                                        styleContainer={{flex:"2"}}
                                    />
                                    <FlexLayout align="center" style={{"margin":"35px 0 0 0", "flex": "0 1 14%"}}>
                                        <Field
                                            name="hasPurchaseOrderCode"
                                            type="checkbox"
                                            style={{ zoom: '1.3' }}
                                            checked={!hasPurchaseOrderCode}
                                            onChange={() => handleNotHasPurchaseOrderCode(setFieldValue)}
                                            data-testid='checkbox-order-code'
                                        />
                                        <label style={{ marginLeft: '5px', fontSize: '12px', marginBottom: '0' }}>Sem ARF</label>
                                    </FlexLayout>
                                </FlexLayout>


                                <FormField
                                    label="create.receivement.form.invoiceValue"
                                    fieldType="number"
                                    name="invoiceValue"
                                    onBlur={() => { validateField("invoiceValue"); setTouched(values) }}
                                    testId='input-invoice-value'
                                    onKeyPress={(event) => {
                                        if (event.key === "Enter") {
                                            checkboxRef.current.focus();
                                        }
                                    }} />
                                <FlexLayout style={{ margin: '15px 0 0 0' }}>
                                    <Field
                                        name="haveBilletBarcode"
                                        type="checkbox"
                                        style={{ zoom: '1.3' }}
                                        onChange={() => ShowBilletBarCode(!haveBillet)}
                                        checked={haveBillet}
                                        innerRef={checkboxRef}
                                        onKeyPress={(event) => {
                                            if (event.key === "Enter") {
                                                event.target.click();
                                                setTimeout(() => !haveBillet && billetBarCodeRef.current.focus(), 50);
                                            }
                                        }} />
                                    <label style={{ marginLeft: '5px', fontSize: '12px' }}> Esse recebimento possuí boleto bancário ?</label>
                                </FlexLayout>
                                {
                                    haveBillet &&
                                    <div>
                                        <FormField
                                            label="receivement.form.billetBarCode"
                                            name="billetBarCode"
                                            onBlur={() => { validateField("billetBarCode"); setTouched(values); }}
                                            fieldRef={billetBarCodeRef}
                                        />
                                    </div>
                                }

                                {error
                                    && <div><p style={{ color: 'red', marginTop: '20px', fontSize: '1.3em' }}>{error}</p></div>}
                                {(status && status.error) && <Text style={{ color: 'red' }}>{status.error}</Text>}

                                <FlexLayout justify="end" style={{ margin: '10px 5px 0 0' }}>
                                    <Button type="button" text="create.receivement.submit" style={{ marginRight: '5px' }} onClick={!isSubmitting ? () => handleSubmit() : () => {}} isDisabled={isSubmitting} testId='button-submit-receivement' />
                                </FlexLayout>
                            </Form>
                        )}
                    </Formik>
                </FlexLayout> :
                <FlexLayout >
                    <div style={{ width: '30%' }} >
                        <Text textType="label" text={provider} testId='chegouaqui' />
                        <Text textType="label" text={invoiceNumber} />
                        <ReceivementFreshForm
                            receivementTable={receivementTable}
                            setReadyTable={setReceivementTable}
                            pendencyReceivementTable={pendencyReceivementTable}
                            setNotReadyTable={setPendencyReceivementTable}
                            receivementId={receivementId}
                            barcodeUser={barCodeUser}
                            errorProducts={errorProducts}
                            setErrorProducts={setErrorProducts}
                            fulfillmentCenterId={fc.id}
                        />
                    </div>
                    <FlexLayout direction="column" style={{ width: '70%', margin: '0 0 0 20px' }}>
                        <FlexLayout justify="end">
                            <Button text="finish" style={{ marginRight: '5px' }} onClick={() => { handleFinishReceivement() }} testId='button-finish-receivement' />
                        </FlexLayout>
                        <Text textType="header2" text="receivement.table.done.title" />
                        <ReactTable
                            style={{ fontSize: "0.7em", width: "100%", maxHeight: '400px', marginBottom: '20px', overflowX: "scroll" }}
                            getTdProps={() => { return {
                                style : {
                                    overflow: "hidden"
                                }
                            }}}
                            data={receivementTable}
                            showPageSizeOptions={false}
                            showPageJump={false}
                            pageSizeOptions={[20, 30, 50, 100, 200, 500]}
                            columns={[
                                {
                                    Header: "Descrição",
                                    id: "description",
                                    accessor: "description"
                                },
                                {
                                    Header: "Cód. Barras",
                                    id: "barcode",
                                    accessor: "barcode",
                                    width: 100
                                },
                                {
                                    Header: "Qtd",
                                    id: "amount",
                                    accessor: "amount",
                                    width: 50
                                },
                                {
                                    Header: "Unidade",
                                    id: "receivementMeasureUnity",
                                    accessor: "receivementMeasureUnity",
                                    width: 70
                                },
                                {
                                    Header: "Validade",
                                    id: "expirationDate",
                                    accessor: "expirationDate",
                                    width: 80
                                },
                                {
                                    Header: "Endereço",
                                    id: "address",
                                    accessor: "address",
                                    width: 80
                                },
                                {
                                    Header: "Ação",
                                    id: "actions",
                                    accessor: "actions",
                                    width: 50
                                },
                            ]}
                            defaultPageSize={20}
                            className="-striped -highlight"
                            previousText={"Anterior"}
                            nextText={"Próxima"}
                            loadingText={"Carregando..."}
                            noDataText={"Sem registros"}
                            pageText={'Página'}
                            ofText={'de'}
                            rowsText={'Registros'}
                        />
                        <Text textType="header2" text="receivement.table.done.title" />
                        <ReactTable
                            style={{ fontSize: "0.7em", width: "100%", maxHeight: '400px', overflowX: "scroll" }}
                            getTdProps={() => { return {
                                style : {
                                    overflow: "hidden"
                                }
                              }}}
                            showPageSizeOptions={false}
                            showPageJump={false}
                            data={pendencyReceivementTable}
                            pageSizeOptions={[20, 30, 50, 100, 200, 500]}
                            columns={[
                                {
                                    Header: "Descrição",
                                    id: "description",
                                    accessor: "description"
                                },
                                {
                                    Header: "Cód. Barras",
                                    id: "barcode",
                                    accessor: "barcode",
                                    width: 100
                                },
                                {
                                    Header: "Qtd",
                                    id: "amount",
                                    accessor: "amount",
                                    width: 50
                                },
                                {
                                    Header: "Unidade",
                                    id: "receivementMeasureUnity",
                                    accessor: "receivementMeasureUnity",
                                    width: 70
                                },
                                {
                                    Header: "Validade",
                                    id: "expirationDate",
                                    accessor: "expirationDate",
                                    width: 80
                                },
                                {
                                    Header: "Endereço",
                                    id: "address",
                                    accessor: "address",
                                    width: 80
                                },
                                {
                                    Header: "Ação",
                                    id: "actions",
                                    accessor: "actions",
                                    width: 50
                                },
                            ]}
                            defaultPageSize={20}
                            className="-striped -highlight"
                            previousText={"Anterior"}
                            nextText={"Próxima"}
                            loadingText={"Carregando..."}
                            noDataText={"Sem registros"}
                            pageText={'Página'}
                            ofText={'de'}
                            rowsText={'Registros'}
                        />
                    </FlexLayout>
                </FlexLayout>
            }
        </>
    )
}

export default ReceivementFresh;
